import { Property } from "./interfaces";

export const valorPagoModerador: Property = { title: "Valor de Pago Moderador", type: "integer" }
